import * as React from 'react'

import styled from '@theme/styled-components'

interface GMapObject {
  lat: number
  lng: number
}

interface Props extends GMapObject {
  count: number
  size: number
  onClick: () => void
}

const Cluster = ({ count, size, onClick }: Props) => {
  return (
    <Container onClick={onClick} size={size} fontSize={18 - count.toString().length}>
      {count}
    </Container>
  )
}
export default Cluster

const Container = styled('div')<{ size: number; fontSize: number }>`
  height: ${(props) => props.size}px;
  width: ${(props) => props.size}px;
  border-radius: ${(props) => 4 * props.size}px;

  background: #0053a1;
  border: 1px solid #ffffff;
  font-family: 'Avenir';
  -moz-box-shadow: 0 0 30px #0053a1;
  -webkit-box-shadow: 0 0 30px #0053a1;
  box-shadow: 0 0 15px #0053a1;

  color: white;
  font-family: Avenir, -webkit-pictograph;
  font-weight: 900;
  font-size: ${(props) => props.fontSize}px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  top: ${(props) => -props.size / 2}px;
  left: ${(props) => -props.size / 2}px;

  cursor: pointer;
`
